// DTOs for User Registrations based on provided Swagger

export enum UserRegistrationRole {
  Supervisor,
  Manager,
  Retailer,
  SuperUser,
}

/** The API serialises the .NET enum name, so compare against these directly. */
export type UserRegistrationStatusName = 'Pending' | 'Approved' | 'Rejected' | 'Cancelled';

const STATUS_NAMES: UserRegistrationStatusName[] = ['Pending', 'Approved', 'Rejected', 'Cancelled'];

/** Tolerates the enum name in any casing, or the numeric value from older payloads. */
export function toRegistrationStatus(value: unknown): UserRegistrationStatusName | null {
  if (value === null || value === undefined || value === '') return null;

  if (typeof value === 'number') {
    return STATUS_NAMES[value] ?? null;
  }

  const raw = String(value).trim();
  const numeric = Number(raw);
  if (!Number.isNaN(numeric) && raw !== '') {
    return STATUS_NAMES[numeric] ?? null;
  }

  return STATUS_NAMES.find((s) => s.toLowerCase() === raw.toLowerCase()) ?? null;
}

export interface UserRegistrationAssignmentDto {
  bankId: number;
  branchId?: number | null;
}

export interface UserRegistrationCreateDto {
  targetB2CId?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  documentNumber?: string | null;
  requestedRole?: UserRegistrationRole | null;
  bankId?: number | null;
  branchId?: number | null;
  notes?: string | null;
  assignments?: UserRegistrationAssignmentDto[] | null;
}

export interface UserRegistrationAssignmentResponseDto {
  id: number;
  bankId: number;
  bankName?: string | null;
  branchId?: number | null;
  branchName?: string | null;
}

export interface UserRegistrationHistoryDto {
  id: number;
  status?: string | null;
  changedByB2CId?: string | null;
  comments?: string | null;
  createdAt: string; // ISO date-time
}

export interface UserRegistrationResponseDto {
  id: number;
  targetB2CId?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  documentNumber?: string | null;
  // The API serialises the enum name; older payloads may carry the numeric value
  requestedRole?: UserRegistrationRole | string | null;
  status?: string | null;
  bankId?: number | null;
  bankName?: string | null;
  branchId?: number | null;
  branchName?: string | null;
  notes?: string | null;
  createdAt: string; // ISO date-time
  updatedAt: string; // ISO date-time
  approvedAt?: string | null; // ISO date-time
  rejectedAt?: string | null; // ISO date-time
  rejectionReason?: string | null;
  assignments?: UserRegistrationAssignmentResponseDto[] | null;
  history?: UserRegistrationHistoryDto[] | null;
}

export interface UserRegistrationApprovalDto {
  comments?: string | null;
  assignments?: UserRegistrationAssignmentDto[] | null;
}

export interface UserRegistrationRejectionDto {
  reason?: string | null;
}
